import { render, staticRenderFns } from "./commonRouteInfoList.vue?vue&type=template&id=5e3542fa&scoped=true"
import script from "./commonRouteInfoList.vue?vue&type=script&lang=js"
export * from "./commonRouteInfoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3542fa",
  null
  
)

export default component.exports